export default __webpack_public_path__ + "static/media/Pusher1.a9be3460.jpg";